import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useServicesStatusData } from '../../hooks/useServicesStatusData';
import ServicesStatus from '../ServicesStatus/ServicesStatus';

export default memo(function MainServicesStatus(props) {
    const [t] = useTranslation(['common', 'dashboard']);

    useServicesStatusData(props.getServicesStatusRequest);

    return <ServicesStatus
        description={t('dashboard:services_detail')}
        error={props.servicesStatus.error}
        fetching={props.servicesStatus.fetching}
        services={props.servicesStatus.status}
        title={t('common:service')}
    />;
}, (prevProps, nextProps) =>
        prevProps.servicesStatus === nextProps.servicesStatus &&
        prevProps.getServicesStatusRequest === nextProps.getServicesStatusRequest
);
